var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.25H5.625H15.625",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.25V5C7.5 4.66848 7.6317 4.35054 7.86612 4.11612C8.10054 3.8817 8.41848 3.75 8.75 3.75H11.25C11.5815 3.75 11.8995 3.8817 12.1339 4.11612C12.3683 4.35054 12.5 4.66848 12.5 5V6.25M14.375 6.25V15C14.375 15.3315 14.2433 15.6495 14.0089 15.8839C13.7745 16.1183 13.4565 16.25 13.125 16.25H6.875C6.54348 16.25 6.22554 16.1183 5.99112 15.8839C5.7567 15.6495 5.625 15.3315 5.625 15V6.25H14.375Z",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.375V13.125",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.375V13.125",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6decca0f0cab200e8c3665cd2dbcb1a5.svg";
export { ForwardRef as ReactComponent };